import { render, staticRenderFns } from "./divideTwo.vue?vue&type=template&id=af0b5a60&scoped=true&"
import script from "./divideTwo.vue?vue&type=script&lang=js&"
export * from "./divideTwo.vue?vue&type=script&lang=js&"
import style0 from "./divideTwo.vue?vue&type=style&index=0&id=af0b5a60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0b5a60",
  null
  
)

export default component.exports